/* Handle some navigation related stuff like adding dropdown arrows to navigation item parents with submenus */

class ProfetNewsFeedSidebar {
	constructor() {
		this.newsFeedSidebar = document.querySelector('.news-feed-sidebar');
		this.toggleNewsFeedSidebar = document.querySelector('.toggle-news-feed-sidebar');
	}
	init() {
		if (!this.newsFeedSidebar) {
			return;
		}
		this.handleClicks();
	}
	handleClicks() {
		/* Handle click on the More menu item */
		this.toggleNewsFeedSidebar.addEventListener('click', (event) => {
			event.preventDefault();
			this.newsFeedSidebar.classList.toggle('toggled');
		});
	}
}

window.addEventListener('load', () => {
	window.profetNewsFeedSidebar = new ProfetNewsFeedSidebar();
	window.profetNewsFeedSidebar.init();
});
